import React from 'react';
import { Link } from 'react-router-dom';

const ErrorPage = () => {
    return (
        <div className="error-container">
            <div className="error-content">
                <h1 className="error-code">404</h1>
                <h2 className="error-message">Oops! The page you are looking for doesn't exist.</h2>
                <p className="suggestions">
                    It seems like you've followed a broken link or typed an incorrect URL. Here are some options to help you find what you're looking for:
                </p>
                <ul className="suggestion-list">
                    <li><Link to="/#/">Go back to the Homepage</Link></li>
                    <li><a href="mailto:support@KSDPL?subject=404 Error Help&body=Hello, I encountered a 404 error while trying to access your website.">Contact Support</a></li>


                </ul>
                <div className="error-footer">
                    <p>We're sorry for the inconvenience!</p>
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;
